import { render, staticRenderFns } from "./MarkdownText.vue?vue&type=template&id=71df5146"
import script from "./MarkdownText.vue?vue&type=script&lang=js"
export * from "./MarkdownText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports